import React, { createContext, useContext, useState } from "react";

import MediaModal from "../components/media-modal";
import MediaUploadModal from "components/media-upload-modal";

export const MODAL_TYPES = {
  MEDIA_MODAL: "MEDIA_MODAL",
  MEDIA_UPLOAD_MODAL: "MEDIA_UPLOAD_MODAL"
/*   CREATE_MODAL: "CREATE_MODAL",
  DELETE_MODAL: "DELETE_MODAL",
  UPDATE_MODAL: "UPDATE_MODAL" */
};

const MODAL_COMPONENTS = {
  [MODAL_TYPES.MEDIA_MODAL]: MediaModal,
  [MODAL_TYPES.MEDIA_UPLOAD_MODAL]: MediaUploadModal
/*   [MODAL_TYPES.CREATE_MODAL]: CreateModal,
  [MODAL_TYPES.DELETE_MODAL]: DeleteModal,
  [MODAL_TYPES.UPDATE_MODAL]: UpdateModal */
};

const initalState = {
  showModal: () => {},
  hideModal: () => {},
  store: {}
};

const GlobalModalContext = createContext(initalState);
export const useGlobalModalContext = () => useContext(GlobalModalContext);

export const GlobalModal = ({ children }) => {
  //debugger;
  const [store, setStore] = useState();
  const { modalType, modalProps } = store || {};

  const showModal = (modalType, modalProps = {}) => {
    //document.body.style.overflow = 'hidden';
    setStore({
      ...store,
      modalType,
      modalProps
    });
  };

  const hideModal = () => {
    //document.body.style.overflow = 'visible';
    setStore({
      ...store,
      modalType: null,
      modalProps: {}
    });
  };

  const renderComponent = () => {
    const ModalComponent = MODAL_COMPONENTS[modalType];
    //console.log("ModalComponent:" + ModalComponent); // TODO remove
    if (!modalType || !ModalComponent) {
      return null;
    }
    return <ModalComponent id="global-modal" {...modalProps} />;
  };

  return (
    <GlobalModalContext.Provider value={{ store, showModal, hideModal }}>
      {renderComponent()}
      {children}
    </GlobalModalContext.Provider>
  );
};